import {
  FETCH_ADMIN,
  SUBMIT_ADMIN,
  DELETE_ADMIN,
  REFRESH_ADMIN_DATATABLES,
  RESET_STORE,
} from '../actions/_types';

const initialState = {
  result: [],
  submitResult: {},
  deleteResult: {},

  refresh: false,
};

export default function admin(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADMIN:
      return {
        ...state,
        result: action.result,
      };

    case SUBMIT_ADMIN:
      return {
        ...state,
        submitResult: action.result,
      };

    case DELETE_ADMIN:
      return {
        ...state,
        deleteResult: action.result,
      };

    case REFRESH_ADMIN_DATATABLES:
      return {
        ...state,
        refresh: !state.refresh,
      };

    case RESET_STORE:
      return { ...initialState };

    default:
      return state;
  }
}
